<ng-container *ngIf="isOpen">
    <div class="panel-backdrop" @backdropFade (click)="close()"></div>
    <div
        class="panel"
        [ngClass]="panelClass"
        @panelSlide
        [style.width]="width"
        (click)="onPanelClick($event)"
    >
        <ng-content></ng-content>
    </div>
</ng-container>